import get from 'lodash/get';
import { FETCH_OVERVIEW_DATA_CAMPAIGN, FETCH_OVERVIEW_DATA_PAGE_TYPE, fetchOverDataActionType } from '../actionTypes';

export const startFetchingOverviewData = () => {
  return {
    type: fetchOverDataActionType.START_FETCHING_OVERVIEW_DATA
  };
};
export const successFetchingOverviewData = payload => {
  return {
    type: fetchOverDataActionType.SUCCESS_FETCHING_OVERVIEW_DATA,
    payload
  };
};
export const failureFetchingOverviewData = payload => {
  return {
    type: fetchOverDataActionType.FAILURE_FETCHING_OVERVIEW_DATA,
    payload
  };
};
export const clearOverviewData = payload => {
  return {
    type: fetchOverDataActionType.CLEAR_OVERVIEW_DATA,
    payload
  };
};

export const fetchOverviewData = payload => dispatch => {
  const { filters, benchmark } = payload;

  dispatch(clearOverviewData());
  dispatch(startFetchingOverviewData());
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      body: {
        filters: filters,
        // filters: {
        //   start_date: '2025-08-04',
        //   end_date: '2025-11-15',
        //   additional_filters: {
        //     property_id: ['M69215']
        //   }
        // },
        benchmark
      },
      queryParams: {
        page_type: FETCH_OVERVIEW_DATA_PAGE_TYPE,
        campaign: FETCH_OVERVIEW_DATA_CAMPAIGN
      }
    },
    onSuccess: ({ data }) => {
      const widgetList = get(data, 'data.widget_list[0].contents.contents');
      dispatch(successFetchingOverviewData(widgetList));
    },
    onError: ({ error }) => {
      dispatch(failureFetchingOverviewData({ error }));
    }
  });
};

export const fetchTopicFiltersData = payload => dispatch => {
  const { onSuccess, pageType, onError, filters } = payload;
  const { filters: t, benchmark } = filters;

  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      body: {
        filters: t,
        benchmark
      },
      queryParams: {
        page_type: FETCH_OVERVIEW_DATA_PAGE_TYPE,
        campaign: pageType
      }
    },
    onSuccess: ({ data }) => {
      const topicData = get(data, 'data.widget_list[0].contents.contents[0]');
      onSuccess(topicData);
    },
    onError: ({ error }) => {
      onError && onError(error);
    }
  });
};
